<template>
  <v-form :aria-label="$t('Login')">
    <v-text-field
      :placeholder="$t('usuario@email.com')"
      v-model="formdata.username"
      color="primary"
      name="email"
      outline
      :label="$t('Usuario')"
      required
    ></v-text-field>

    <v-text-field
      :placeholder="$t('Contraseña')"
      @keypress.enter="login"
      v-model="formdata.password"
      color="primary"
      name="password"
      outline
      type="password"
      :label="$t('Contraseña')"
      required
    ></v-text-field>

    <div class="text-md-center">
      <router-link style="color: #A19E9E" to="/password">
        {{ $t('Olvidé mi contraseña') }}
      </router-link>
    </div>

    <v-layout justify-center row>
      <v-flex xs6>
        <v-btn @click="login" round large class="my-4 black--text" color="primary">
          {{ $t('Entrar') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout justify-center row>
      <v-flex>
        <p style="color: #A19E9E; font-size: 18px; margin-top: 5rem">
          O si prefieres, inicia sesión con Google
        </p>
        <a :href="googleLoginUrl">
          <img src="/img/btn-login-google.png" />
        </a>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import authApi from '../services/auth-api.js';
export default {
  data() {
    return {
      formdata: {
        username: '',
        password: '',
        verify: false,
      },
      showPasswordRecovery: false,
      passwordRecoveryData: {
        email: '',
      },
    };
  },
  mounted() {
    this.initialize();
  },
  computed: {
    googleLoginUrl() {
      return authApi.googleLoginUrl();
    },
  },
  methods: {
    initialize() {},
    login: function() {
      console.log('LOGIN CLICKED');
      this.$store
        .dispatch('login', this.formdata)
        .then(() => this.$router.push('/dashboard'))
        .catch(err => console.log(err));
    },
    passwordRecovery() {
      this.passwordRecoveryData.frontUrl = this.getCurrentHostUrl('/password');
      authApi.resetPassword(this.passwordRecoveryData).then(res => {
        //this.$router.push('/login');
      });
    },

    getCurrentHostUrl(url = '') {
      let hostUrl = location.protocol + '//' + location.host;
      return hostUrl + url;
    },
    // submit() {
    //     authApi.login(this.formdata).then(res => {
    //         console.log(res);
    //         localStorage.setItem('token', res.data.access_token);
    //         this.$router.push(this.$route.query.redirect || '/');
    //     })
    //     console.log(this.formdata)
    // }
  },
};
</script>
<style lang="scss">
.login-container {
  max-width: 600px;
  margin: 0 auto;
}
</style>
